import { Page } from '@react-pdf/renderer'
import React, { useEffect } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import AbandonedCartList from './AbandonedCartList';

const AbandonedCart = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'abandoned-cart'
        });
    }, []);
  return (
    <>
        <PageHeaderLayout headerTitle={'Abandoned Cart'}>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>}>
                Back
            </Button>
        </PageHeaderLayout>
        <AbandonedCartList/>
    </>
  )
}

export default AbandonedCart